import TrueFalse from "./TrueFalse";
import MultipleChoice from "./MultipleChoice";

const QuestionTypes = [
  TrueFalse,
  MultipleChoice
];

export default QuestionTypes;